import { useMediaQuery } from '@material-ui/core'
import * as React from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'

const StyledImg = styled.img`
  height: 36px;
  width: 36px;
  margin-right: 10px;
`

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 10px;
  margin-right: 15px;

  @media (min-width: 43em) {
    margin-left: 25px;
  }
`

const GlassText = styled.div`
  font-weight: 400;
  letter-spacing: 0.2rem;
  font-size: 36px;
  color: white;
`

const Logo = (): JSX.Element => {
  const isMobile = useMediaQuery('(max-width: 43em)')
  const router = useRouter()

  return (
    <StyledDiv onClick={() => router.push('/')}>
      <StyledImg src={`https://glassimg.imgix.net/new-icon.png?w=108&h=108&fm=webp`}></StyledImg>
      {!isMobile && <GlassText>GLASS</GlassText>}
    </StyledDiv>
  )
}

export default Logo
